import { render } from "./HotelindexComponent.vue?vue&type=template&id=ef35d436"
import script from "./HotelindexComponent.vue?vue&type=script&lang=js"
export * from "./HotelindexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__